<template>
  <v-container>
    <v-snackbar v-model="snackbar" top rounded="pill" color="primary">
      <v-icon left>mdi-alert-decagram</v-icon><b>Pump turned {{ status }}</b>
    </v-snackbar>
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-card color="accent" dark elevation="14">
          <v-card-title class="headline">
            <h4>Gauges</h4>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="fetchData"
              :loading="btnLoading"
              :disabled="btnLoading"
              >Refresh</v-btn
            >
          </v-card-title>

          <v-divider></v-divider>
          <v-col>
            <v-row>
              <v-col cols="6">
                <Gauge
                  :value="waterTank.TankLitres"
                  title="Tank Litres"
                  max="3000"
                  greenFrom="200"
                  greenTo="3000"
                  redFrom="0"
                  redTo="200"
                  minorTicks="10"
                />
              </v-col>
              <v-col cols="6">
                <Gauge
                  :value="waterTank.WaterTemperature"
                  title="Temp °C"
                  max="20"
                  greenFrom="8"
                  greenTo="20"
                  redFrom="0"
                  redTo="5"
                  redColor="#0080ff"
                  yellowFrom="5"
                  yellowTo="8"
                  minorTicks="5"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <Gauge
                  :value="bufferTank.ACS"
                  title="ACS"
                  max="100"
                  greenFrom="40"
                  greenTo="70"
                  redFrom="70"
                  redTo="100"
                  yellowFrom="30"
                  yellowTo="40"
                  yellowColor="#0080ff"
                  minorTicks="10"
                />
              </v-col>
              <v-col cols="4">
                <Gauge
                  :value="bufferTank.UFHflow"
                  title="UFH Flow"
                  max="100"
                  greenFrom="30"
                  greenTo="50"
                  redFrom="50"
                  redTo="100"
                  yellowFrom="20"
                  yellowTo="30"
                  yellowColor="#0080ff"
                  minorTicks="10"
                />
              </v-col>
              <v-col cols="4">
                <Gauge
                  :value="bufferTank.UFHreturn"
                  title="UFH Return"
                  max="100"
                  greenFrom="30"
                  greenTo="50"
                  redFrom="50"
                  redTo="100"
                  yellowFrom="10"
                  yellowTo="30"
                  yellowColor="#0080ff"
                  minorTicks="10"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <Gauge
                  :value="bufferTank.FIREflow"
                  title="Fire Flow"
                  max="100"
                  greenFrom="50"
                  greenTo="90"
                  redFrom="90"
                  redTo="100"
                  yellowFrom="0"
                  yellowTo="40"
                  yellowColor="#0080ff"
                  minorTicks="10"
                />
              </v-col>
              <v-col cols="6">
                <Gauge
                  :value="bufferTank.FIREreturn"
                  title="Fire Return"
                  max="100"
                  greenFrom="40"
                  greenTo="90"
                  redFrom="90"
                  redTo="100"
                  yellowFrom="30"
                  yellowTo="40"
                  yellowColor="#0080ff"
                  minorTicks="10"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-card class="radius" color="accent" elevation="14">
          <v-simple-table dark style="background-color: #384263">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Function
                  </th>
                  <th class="text-left">
                    Status
                  </th>
                  <th class="text-left">
                    Option
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Pump</td>
                  <td>
                    {{ status }}
                  </td>
                  <td>
                    <v-switch
                      color="#80b918"
                      v-model="switch1"
                      inset
                    ></v-switch>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Gauge from "@/components/Gauge";

export default {
  components: {
    Gauge,
  },
  data() {
    return {
      btnLoading: false,
      switch1: false,
      snackbar: false,
    };
  },
  computed: {
    ...mapState({
      waterTank: (state) => state.mill.waterTank,
      bufferTank: (state) => state.mill.bufferTank,
    }),

    status() {
      if (this.switch1 === true) {
        return "On";
      } else {
        return "Off";
      }
    },
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    switch1: function() {
      this.snackbar = true;
    },
  },
  methods: {
    async fetchData() {
      try {
        this.btnLoading = true;
        await this.$store.dispatch("fetchWaterTank");
        await this.$store.dispatch("fetchBufferTank");
        setTimeout(() => {
          this.btnLoading = false;
        }, 1000);
      } catch {
        alert("Whoops!");
      }
    },
  },
};
</script>

<style lang="scss">
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
